import React from 'react'

function PriceUpdates() {
  return (
    <div className='textpage'>
        <img className='textlogo' src="https://i.imgur.com/Yan6SO9.jpg" alt="logo" />
        <h1><b>Price Adjustments</b></h1>
        <p>We are here to offer you the utmost service quality and experience. In order to continue giving you our best, you may see some price adjustments starting July 1.
        <br/>
        <br/>
        Due to inflation and the rising cost of goods there will be a 5-10% increase in some services. Please check the website at <a href="https://www.materialtampa.com/">www.materialtampa.com</a> for updated pricing.
        <br/>
        <br/>
        We thank you all for your continued support and loyalty.
        If you have any questions please email us at <a href="mailto:contact@materialtampa.com">contact@materialtampa.com</a></p>
    </div>
  )
}

export default PriceUpdates